"use client";

import { PrinterIcon } from "@heroicons/react/24/outline";

import { Button, type ButtonProps } from "@/components/ui/button";

export const PrintButton = (props: ButtonProps) => (
  <Button
    type="button"
    variant="outline"
    className="print:hidden"
    onClick={() => {
      // Force a small delay to ensure styles are applied
      setTimeout(() => {
        window.print();
      }, 100);
    }}
    {...props}
  >
    <PrinterIcon className="mr-2 size-4" /> Imprimir
  </Button>
);
